<div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
  <h5 class="modal-title" style="font-size: 15px;">Tank Details [ TLS Id: {{selectedItem?.tlstankID}} | Name:
    {{selectedItem?.tankName}} ]</h5>
  <button type="button" class="close" aria-label="Close" (click)="close('Cross click')">
    <span aria-hidden="true" style="color: white">&times;</span>
  </button>
</div>
<div class="modal-body table-responsive">
  <div class="row">
    <div class="col-6 left" id="style-1" style="max-height: 600px; overflow-x: hidden;">
      <div class="row">
        <div class="col-6">
          <h6>Stick Readings</h6>
        </div>
        <div class="col-6">Zero in inches is manual reading</div>
      </div>
      <table class="table table-striped" style="font-size: 12px;font-size: 11px;
        padding: 83px;
        margin-top: 8px;
        margin-left: -4px;">
        <thead style="background-color: #9a9a9a" class="text-center">
          <tr>
            <th>
              <b>DOW </b>
            </th>
            <th>
              <b>Date </b>
            </th>
            <th>
              <b>Time </b>
            </th>
            <th>
              <b>Inches </b>
            </th>
            <th>
              <b>Gallons </b>
            </th>
            <th>
              <b>Ullage </b>
            </th>
            <th>
              <b>Water </b>
            </th>
          </tr>
        </thead>
        <tbody [hidden]="!selectedItem" class="text-center" *ngIf="readings && readings.length > 0">
          <tr *ngFor="let reading of readings[0]">
            <td>{{reading?.date | date: 'EEE'}}</td>
            <td>{{reading?.date | date: 'MM/dd/yy'}}</td>
            <td>{{reading?.invTime | date: 'HH:mm'}}</td>
            <td>{{reading?.inches| number: '1.1-2'}}</td>
            <td>{{reading?.gallons| number: '1.0-0'}}</td>
            <td>{{reading?.ullage}}</td>
            <td>{{reading?.water}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-6 right" id="style-1" style="overflow-x: hidden;">
      <h6>Deliveries</h6>
      <table class="table table-striped" style="font-size: 12px;font-size: 11px;
        padding: 83px;
        margin-top: 8px;
        margin-left: -4px;">
        <thead style="background-color: #9a9a9a" class="text-center">
          <tr>
            <th>
              <b>DOW </b>
            </th>
            <th>
              <b>Date </b>
            </th>
            <th>
              <b>Gallons </b>
            </th>
            <th>
              <b>Time </b>
            </th>
          </tr>
        </thead>
        <tbody [hidden]="!selectedItem" class="text-center">
          <tr *ngFor="let delivery of deliveries?.content">
            <td>{{delivery?.date | date: 'EEE'}}</td>
            <td>{{delivery?.date | date: 'MM/dd/yy'}}</td>
            <td>{{delivery?.gallons | number: '1.0-0'}}</td>
            <td>{{delivery?.date | date: 'hh:mm aa'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary close-modal" (click)="close('Close click')">Close</button>
</div>